// extracted by mini-css-extract-plugin
module.exports = {"im-modal":"category_im-modal__bPHha","im-container":"category_im-container__pwNYH","im-item-container":"category_im-item-container__Dx6mG"};